import { useSearchParams, usePathname, useRouter } from 'next/navigation'
import { type FC } from 'react'
import type { TermItem } from 'models/termItem'

export interface ISearchTermsProps {
  termData: TermItem[]
  className?: string
}

export const SearchTerms: FC<ISearchTermsProps> = ({ termData, className }) => {
  const searchParams = useSearchParams()
  const pathname = usePathname()
  const { replace } = useRouter()

  const handleSearch = (term: string) => {
    const params = new URLSearchParams(searchParams)
    if (term) {
      params.set('search', term)
    } else {
      params.delete('search')
    }
    replace(`${pathname}?${params.toString()}`, { scroll: false })
  }

  const handleLetter = (letter: string) => {
    const params = new URLSearchParams(searchParams)

    let selectedLetters = params.get('letters')?.split('-') || []
    const includeLetter =
      selectedLetters.filter(l => {
        return l === letter
      }).length > 0

    if (includeLetter) {
      selectedLetters = selectedLetters.filter(l => {
        return l !== letter
      })
    } else {
      selectedLetters.push(letter)
    }

    if (selectedLetters.length === 0) {
      params.delete('letters')
    } else {
      params.set('letters', selectedLetters.join('-'))
    }

    replace(`${pathname}?${params.toString()}`, { scroll: false })
  }

  const getTerms = () => {
    const params = new URLSearchParams(searchParams)
    const selectedLetters = params.get('letters')?.split('-') || []
    const searchValue = params.get('search') || ''

    if (termData) {
      return termData
        ?.filter((term: TermItem) => {
          let isShow = true

          if (selectedLetters.length > 0) {
            isShow =
              selectedLetters.filter(l => {
                return l === term.name[0]?.toLowerCase()
              }).length > 0
          }

          if (isShow && searchValue) {
            isShow =
              term.name.toLowerCase().indexOf(searchValue.toLowerCase()) > -1 ||
              term.description.toLowerCase().indexOf(searchValue.toLowerCase()) > -1
          }

          return isShow
        })
        .map((term: TermItem, index: number) => {
          return (
            <div role="listitem" className="w-dyn-item" key={index}>
              <a href={`/glossary/${term.slug}`} className="listing-link w-inline-block">
                <div className="content-listing-card" style={{ backgroundColor: term.colorCode }}>
                  <div
                    id="w-node-_6950ab59-a50a-96e0-668e-0ebb5626b86e-09f1eb78"
                    className="heading-set-2"
                  >
                    <div className="heading-set-3">
                      <h1 className="listing-card-heading">{term.name}</h1>
                      <p className="paragraph-regular">{term.description}</p>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          )
        })
    } else {
      return <div></div>
    }
  }

  return (
    <section className="section-3">
      <div className={`${className ? className : 'overlapping-div'}`}>
        <div className="container-regular">
          <div className="glossary-letter-wrap jetboost-filter-z8g7 w-dyn-list">
            <div role="list" className="glossary-letter-group w-dyn-items">
              {'abcdefghijklmnopqrstuvwxyz'.split('').map(letter => {
                return (
                  <div
                    key={letter}
                    onClick={handleLetter.bind(this, letter)}
                    role="listitem"
                    className="w-dyn-item"
                  >
                    <div
                      style={{ cursor: 'pointer' }}
                      className={`glossary-letter-link jetboost-filter-trigger ${
                        (searchParams.get('letters')?.split('-') || []).filter(l => {
                          return l === letter
                        }).length > 0 && 'jetboost-filter-active'
                      }`}
                    >
                      {letter.toUpperCase()}
                    </div>
                    <div className="w-embed">
                      <input type="hidden" className="jetboost-list-item" value={letter} />
                    </div>
                  </div>
                )
              })}
            </div>
          </div>

          <div className="w-layout-grid glossary-content-grid">
            <div
              id="w-node-_6c8438d0-a7d7-8c3f-0c55-dbd6c89c553b-09f1eb78"
              className="glossary-content-card"
            >
              <div className="gloosary-list-wrapper jetboost-list-wrapper-z8g7 jetboost-list-wrapper-kwl7 w-dyn-list">
                <div role="list" className="glossary-listing w-dyn-items">
                  {getTerms()}
                </div>
              </div>
            </div>
            <div
              id="w-node-_6c8438d0-a7d7-8c3f-0c55-dbd6c89c5574-09f1eb78"
              className="newsletter-block"
            >
              {/* <div className="newsletter-icon">
                <div className="icon-large w-embed">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M25.3333 4H6.66667C5.2 4 4 5.2 4 6.66667V25.3333C4 26.8 5.2 28 6.66667 28H25.3333C26.8 28 28 26.8 28 25.3333V6.66667C28 5.2 26.8 4 25.3333 4ZM25.3333 6.66667V18.6667H20.5867C20.1067 18.6667 19.68 18.92 19.44 19.3333C18.7467 20.5333 17.48 21.3333 16 21.3333C14.52 21.3333 13.2533 20.5333 12.56 19.3333C12.32 18.92 11.88 18.6667 11.4133 18.6667H6.66667V6.66667H25.3333Z"
                      fill="currentColor"
                    ></path>
                  </svg>
                </div>
              </div> */}
              <div className="wrap-v-small">
                <h6 className="h6-heading">Search on Glossary</h6>
                {/* <p className="paragraph-regular">Type words you want to search.</p> */}
              </div>
              <form action="/search" className="glossary-search w-form">
                <div className="search-input-wrapper">
                  <input
                    className="search-input jetboost-list-search-input-kwl7 w-input"
                    max="256"
                    name="query"
                    placeholder="acquisition, decacorn.."
                    type="search"
                    id="search"
                    value={searchParams.get('search') || ''}
                    onChange={event => {
                      handleSearch(event.target.value)
                    }}
                  />
                  <div className="search-icon">
                    <div className="icon-small w-embed">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.6502 9.64771H10.1235L9.93682 9.46771C10.7368 8.53438 11.1502 7.26105 10.9235 5.90772C10.6102 4.05438 9.06349 2.57438 7.19682 2.34772C4.37682 2.00105 2.00349 4.37438 2.35016 7.19438C2.57682 9.06105 4.05682 10.6077 5.91016 10.921C7.26349 11.1477 8.53682 10.7344 9.47016 9.93438L9.65016 10.121V10.6477L12.4835 13.481C12.7568 13.7544 13.2035 13.7544 13.4768 13.481C13.7502 13.2077 13.7502 12.761 13.4768 12.4877L10.6502 9.64771ZM6.65016 9.64771C4.99016 9.64771 3.65016 8.30771 3.65016 6.64772C3.65016 4.98772 4.99016 3.64772 6.65016 3.64772C8.31016 3.64772 9.65016 4.98772 9.65016 6.64772C9.65016 8.30771 8.31016 9.64771 6.65016 9.64771Z"
                          fill="currentColor"
                        ></path>
                      </svg>
                    </div>
                  </div>
                </div>
                {/* <input type="submit" className="button-primary w-button" value="Search" /> */}
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
